import {
  BrandKit,
  InputStyleDefinition,
  Override,
} from "@redotech/redo-content-builder-common/brand-kit";
import { getInputStyles } from "@redotech/redo-content-builder-common/brand-kit/utils";
import { InputStyleOverride } from "@redotech/redo-content-builder-common/element-schema";
import {
  RedoDateInput,
  RedoDateInputProps,
} from "./arbiter-components/input/redo-date-input";
import * as css from "./brand-kit-text-input.module.css";

export const BrandKitDateInput = function BrandKitDateInput({
  brandKit,
  override,
  elementOverride,
  ...props
}: RedoDateInputProps & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
  elementOverride?: InputStyleOverride | null;
}) {
  const style = getInputStyles(brandKit, override, elementOverride);
  return (
    <RedoDateInput
      className={css.brandKitTextInput}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      {...props}
    />
  );
};
